export * as api from './api/index.js';
export { fetchApi, fetchAllApi, callAPI, getAPI } from './fetchApi';
import URLS, {
    apiHost,
    apiPrefix,
    siteHost,
    fileHost,
} from './urls.js';

URLS.apiHost = apiHost;
URLS.siteHost = siteHost;
URLS.fileHost = fileHost;
URLS.apiPrefix = apiPrefix;

export { URLS };
export { POST, GET, DELETE, PUT, HEAD, OPTIONS, UPLOAD } from './http';
